import { NavLink, Link } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  BarChart3,
  MessageSquare,
  Video,
  GraduationCap,
  AlertCircle,
  BookOpen,
} from "lucide-react";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarFooter,
  useSidebar,
} from "@/components/ui/sidebar";
import { Separator } from "@/components/ui/separator";

const menuItems = [
  { title: "ダッシュボード", url: "/dashboard", icon: LayoutDashboard },
  { title: "受講生管理", url: "/students", icon: Users },
  { title: "コース管理", url: "/courses", icon: GraduationCap },
  { title: "分析", url: "/analytics", icon: BarChart3 },
  { title: "AIチャット", url: "/chat", icon: MessageSquare },
  { title: "動画管理", url: "/videos", icon: Video },
  { title: "エスカレーション", url: "/escalations", icon: AlertCircle },
  { title: "ヘルプ", url: "/docs", icon: BookOpen },
];

export function AppSidebar() {
  const { state } = useSidebar();

  const isCollapsed = state === "collapsed";

  return (
    <Sidebar
      className={isCollapsed ? "w-14" : "w-60"}
      collapsible="icon"
      role="navigation"
      aria-label="メインナビゲーション"
    >
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel className={isCollapsed ? "sr-only" : ""}>
            学習管理システム
          </SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu role="menubar" aria-label="メニュー">
              {menuItems.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton asChild>
                    <NavLink
                      to={item.url}
                      className={({ isActive }) =>
                        isActive
                          ? "bg-muted text-primary font-medium"
                          : "hover:bg-muted/50"
                      }
                    >
                      {({ isActive }) => (
                        <>
                          <item.icon className="h-4 w-4" aria-hidden="true" />
                          {!isCollapsed && <span>{item.title}</span>}
                          {isActive && <span className="sr-only">（現在のページ）</span>}
                        </>
                      )}
                    </NavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>

      <SidebarFooter>
        {!isCollapsed && (
          <div className="p-2 space-y-2">
            <Separator />
            <div className="flex justify-center gap-4 text-xs text-muted-foreground">
              <Link to="/terms" className="hover:text-primary underline">
                利用規約
              </Link>
              <Link to="/privacy" className="hover:text-primary underline">
                プライバシー
              </Link>
            </div>
          </div>
        )}
      </SidebarFooter>
    </Sidebar>
  );
}
